import BackgroundFilesGetListResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/BackgroundFilesService/BackgroundFilesGetListResponse";
import { formatTranslations } from "@/filters/translations";



export default class BackgroundFileItem {
    id: string = '';
    name: string = '';
    constructor(res: BackgroundFilesGetListResponse) {
        this.id = res.Id;
        this.name = formatTranslations(res.Translations, 'LangCode: Name', '  /  ');
    }
}